import { Component, OnInit } from '@angular/core';
import { ContactService } from 'src/app/services/contact.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  form = { name: '', email: '', phone: '', message: '' };

  constructor(private contactService: ContactService) {}

  ngOnInit(): void {
  }


    enviar() {
      console.log('Formulario enviado:', this.form); // <--- para depuración
      this.contactService.sendMessage(this.form).subscribe(
        res => {
          console.log('Respuesta del backend:', res);
          alert('Mensaje enviado!');
          this.form = { name: '', email: '', phone: '', message: '' }; // limpiar form
        },
        err => {
          console.error('Error al enviar:', err);
          alert('Error al enviar');
        }
      );
    }


}